module.exports = __webpack_public_path__ + "img/curriculum.ba9668c0.png";